// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"B5-z"};